// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"484":"b79f9323","551":"055502a9"}[chunkId] + ".chunk.js");